import { z } from "zod/v4";
const NUMBER_STRINGS = "0123456789";
const NUMBER_ID_LENGTH = 16;
const NumberIdentitySchema = z
    .string()
    .length(NUMBER_ID_LENGTH)
    .regex(/^\d+$/)
    .brand();
const generate = () => {
    const id = Array.from(crypto.getRandomValues(new Uint32Array(NUMBER_ID_LENGTH)))
        .map((n) => NUMBER_STRINGS[n % NUMBER_STRINGS.length])
        .join("");
    return NumberIdentitySchema.parse(id);
};
const shortId = (id) => {
    return id.slice(-6, NUMBER_ID_LENGTH);
};
export const NumberIdentity = {
    schema: NumberIdentitySchema,
    generate,
    shortId,
};
//# sourceMappingURL=number-identity.js.map